import { render, staticRenderFns } from "./publishMarket.vue?vue&type=template&id=5ec18397&scoped=true&"
import script from "./publishMarket.vue?vue&type=script&lang=js&"
export * from "./publishMarket.vue?vue&type=script&lang=js&"
import style0 from "./publishMarket.vue?vue&type=style&index=0&id=5ec18397&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec18397",
  null
  
)

component.options.__file = "publishMarket.vue"
export default component.exports